import React from "react";
import Contabilidade from "../../components/PortalHome/Contabilidade";

import "./style.css"

function PageContabilidade() {

  return (
    <>
      <div className="centralizar">
        <Contabilidade />
      </div>
    </>
  );
}
export default PageContabilidade;
